module.exports = __webpack_public_path__ + "static/img/img_m.aedcc00f.png";